<template>
  <section class="hero paris">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
            DNA HOUSE, Paris at <a href="https://maps.app.goo.gl/9sWoqbrU3L1GwRkm9" target="_blank">Kitchen by Madame Rêve</a>
          </h1>
          <h2 class="hero__date">
            April 9th, 2025
          </h2>
          <a href="http://lu.ma/dnafund" target="_blank">
            <button class="hero__btn">
              Register Now
            </button>
          </a>
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "@/styles/components/hero.scss";

  .hero.paris {
    padding: 100px 0 20px;
    min-height: 500px;
    background-image: linear-gradient(to bottom, rgb(0 0 0 / 85%) 0%, rgb(0 0 0 /40%)), url('~@/assets/general/reve.jpg');
    background-position: center;
  }
  </style>